import React from 'react'

import clsx from 'clsx'

import Card, { CardActionArea } from 'components/Card'
import { FixedImage } from 'components/NextImage'
import Rating from 'components/Rating'
import { useEventContext } from 'context/EventContext'

import classes from './ItemCard.module.scss'

const ItemCard = ({ listing: { cta_urls, name, logo_url, rating_avg, num_reviews, global_product_id } }) => {
  const eventContext = useEventContext({
    name: 'click',
    engagementComponent: 'contenders',
    engagementDetails: 'card_product',
    productClickUUID: global_product_id,
  })

  return (
    <Card className={clsx('ItemCard', classes.root)} elevation={0}>
      <CardActionArea
        className={classes.alternative}
        href={cta_urls.detail}
        {...eventContext.addEvent({
          engagementDestination: 'go-to_product_details',
        })}
      >
        <div className={classes.logo}>
          <FixedImage fetchWidth={72} width={40} src={logo_url} alt="logo" loading="lazy" />
        </div>
        <div className={classes.info}>
          <div className={classes.name}>{name}</div>
          <Rating.Link className={classes.rating} average={rating_avg} totals={num_reviews} isCompact />
        </div>
      </CardActionArea>
    </Card>
  )
}

export default ItemCard
